import React from 'react';
import { Box, Grid } from '@material-ui/core';

import ListsItem from '../../shared/ListsItem/ListsItem';

interface Props {
  handleOpenEditTask: (id: string, linkedObjectId?: string) => void;
  taskEvents: any[];
  handleEditMode: (status: boolean) => void;
  buildingCollectionId: string;
  buildingAcl: { restrictions: any[] };
  handleOpenDeleteModal: (id: string) => void;
  linkedId?: string;
}

const ObservationTaskList = (props: Props) => {
  const onOpenWithEdit = async (id: string) => {
    await props.handleOpenEditTask(id, props.linkedId);
    props.handleEditMode(true);
    return;
  };

  return (
    <>
      {props.taskEvents.length > 0 && (
        <Box>
          <Grid container>
            {props.taskEvents.map(task => (
              <Grid item xs={12} key={task.artifact_id || task.uuid}>
                <ListsItem
                  item={task}
                  onOpen={() => props.handleOpenEditTask(task.artifact_id || task.uuid, props.linkedId)}
                  onDelete={() => props.handleOpenDeleteModal(task.artifact_id || task.uuid)}
                  onOpenWithEdit={() => onOpenWithEdit(task.artifact_id || task.uuid)}
                  buildingCollectionId={props.buildingCollectionId}
                  buildingAcl={props.buildingAcl}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default ObservationTaskList;
